import { render, staticRenderFns } from "./AssignDriversModal.vue?vue&type=template&id=b47754f2&scoped=true&"
import script from "./AssignDriversModal.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./AssignDriversModal.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./AssignDriversModal.vue?vue&type=style&index=0&id=b47754f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47754f2",
  null
  
)

export default component.exports